












//import { ResponseModel } from "@dataSource/models/responseModels.ts";
import { Component, Vue, Prop } from "vue-property-decorator";
import UiDropdownMenuSubComponent from "./ui-dropdown-menu-sub.vue"

@Component({
  name: "ui-dropdown-menu-item"
})
export default class UiDropdownMenuItemComponent extends Vue {
  @Prop({ default: "" })
  icon: string;
  
  @Prop({ default: 1 })
  item:number;

  @Prop({ default: false, type:Boolean })
  disabled!:boolean


  innderDisabled = this.disabled;
  innerSelected = false;

  onClick(value:MouseEvent){
    let menu = this.$children[0] as any;
    // debugger
    if (menu!=null) {
      menu.show(value)
    }
    if (!this.innderDisabled && menu==null)
       this.$emit("clickItem",this.item)
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/dropdown-menu/src/ui-dropdown-menu-item.vue